<template>
    <div class="search-result">
        <!-- ============= 顶部背景图 ============= -->
        <div class="result-img" style='background: url("web/bk/bk1.png");background-size: 100%;'>
            <table width="990" height="770" cellspacing="0" cellpadding="0" border="0" align="center">
  <tbody>
  
  <tr>
    <td valign="top" height="429" background="images/about_02.gif" align="center">
		<h1>&nbsp;</h1>
		<h1> SinoLink Plus + Keil C51 </h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1qR8FecEno/?spm_id_from=333.999.0.0')">Go to BiliBili to watch</button>
		</h2>
	<iframe src="https://player.bilibili.com/player.html?bvid=BV1qR8FecEno" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
        <h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
        <h1> SinoLink Plus + Keil MDK </h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1qX8FeaEt7/?spm_id_from=333.999.0.0')">Go to BiliBili to watch</button>
		</h2>
	<iframe src="https://player.bilibili.com/player.html?bvid=BV1qX8FeaEt7" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
	<h1> SinoLink Plus + ProWriter </h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1vo8FefEM9/?spm_id_from=333.999.0.0')"> Go to BiliBili to watch </button>
		</h2>
    <iframe src="https://player.bilibili.com/player.html?bvid=BV1vo8FefEM9" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"  sandbox="allow-top-navigation allow-same-origin allow-forms allow-scripts"></iframe>
    <h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
	<h1> ProWriter </h1>
		<h2>
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1GK411M76d/?spm_id_from=333.999.0.0')"> Go to BiliBili to watch </button>
		</h2>
    <iframe src="https://player.bilibili.com/player.html?bvid=BV1GK411M76d" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"  sandbox="allow-top-navigation allow-same-origin allow-forms allow-scripts"></iframe>
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
		<h1>Pro06C</h1>
		<h2>
		<button type="button" onclick="window.open(' https://www.bilibili.com/video/BV1Fk4y1g7Cj/?spm_id_from=333.999.0.0')"> Go to BiliBili to watch </button>&nbsp;&nbsp;
		<button type="button" onclick="window.open('https://www.bilibili.com/video/BV1j78seYEhg/?spm_id_from=333.999.0.0')">Quick Introductions</button>
		</h2>
    <iframe src="https://player.bilibili.com/player.html?bvid=BV1Fk4y1g7Cj" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"  sandbox="allow-top-navigation allow-same-origin allow-forms allow-scripts"></iframe>
		
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
	<h1> Pro06B </h1>
		<h2><button type="button" onclick="window.open('https://www.bilibili.com/video/BV1WA411n7Jy/')">Go to BiliBili to watch</button>
		</h2>
	<iframe src="https://player.bilibili.com/player.html?bvid=BV1WA411n7Jy" allowfullscreen="true" scrolling="no" border="0" framespacing="0" width="640" height="480" frameborder="no"></iframe>
		<h1>&nbsp;</h1>
		<h1>&nbsp;</h1>
		
   </td>
  </tr>
  
</tbody></table>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
            }
        },
        mounted: function (){},
        methods: {
        },
    };
    
</script>



// WEBPACK FOOTER //
// src/pages/product/toolteach.vue